import PropTypes from 'prop-types';
import React from 'react';

import { StyledCard, StyledCardHeader, StyledTitle } from './styles';

const Card = ({ className, title, headerRight: HeaderRight, children }) => {
  return (
    <StyledCard className={className}>
      <StyledCardHeader>
        {title ? <StyledTitle>{title}</StyledTitle> : null}
        {HeaderRight ? <HeaderRight /> : null}
      </StyledCardHeader>
      {children}
    </StyledCard>
  );
};

Card.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.func,
  ]),
  className: PropTypes.string,
  headerRight: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.func,
  ]),
  title: PropTypes.string,
};

Card.defaultProps = {
  children: null,
  className: '',
  headerRight: null,
  title: '',
};

export default Card;
